/**
 * Material Components for the Web -> Version m2
 * https://m2.material.io/components
 *(https://m3.material.io/components -> Version m3)
 *
 * https://github.com/material-components
 */

// console.log("material-comonents.js");



// import {MDCTextField} from '@material/textfield';
// const initFields = () => {
//   const textFields = [].map.call(document.querySelectorAll('.mdc-text-field'), function(el) {
//     return new MDCTextField(el);
//   });
// }
// initFields()


// document.addEventListener("ajax-form-changed", function () {
//   console.log("event: ajax-form-changed");
//   // window.mdc.autoInit();
//   initFields();
// });


// import {MDCMenu} from '@material/menu';
// const menu = new MDCMenu(document.querySelector('.mdc-menu'));
// menu.open = true;

document.addEventListener("ajax-form-changed", function () {
  // console.log("event: ajax-form-changed");
  window.mdc.autoInit();
});
window.mdc.autoInit();


// document.querySelectorAll('.mdc-menu').forEach( (el) => {
//   el.MDCMenu.open = true;
// });

/** 
 * Init click handlers for event date and time fields to open the menu.
 */
function initMenuClickHandlers() {
  document.querySelectorAll('.widget-text--eventdate .mdc-text-field, .widget-text--eventtime .mdc-text-field').forEach(textField => {
    const menu = textField.parentElement.querySelector('.mdc-menu');
    const input = textField.querySelector('.mdc-text-field__input');
    
    if (menu && menu.MDCMenu && input) {
      // Make input readonly to prevent focus and typing
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('tabindex', '-1');
      
      textField.addEventListener('click', () => {
        menu.MDCMenu.open = true;
      });
      
      // Prevent any focus events on the input
      input.addEventListener('focus', (e) => {
        e.preventDefault();
        input.blur();
      });
      
      // Listen for menu selection and update MDC TextField
      menu.addEventListener('MDCMenu:selected', (e) => {
        const selectedItem = e.detail.item;
        const selectedText = selectedItem.textContent.trim();
        
        // Update the input value
        input.value = selectedText;
        
        // Notify MDC TextField that the value has changed
        if (textField.MDCTextField) {
          // Trigger the MDC TextField to update its state
          textField.MDCTextField.foundation.adapter.floatLabel(true);
          // textField.MDCTextField.foundation.adapter.shakeLabel(false);
          // textField.MDCTextField.foundation.adapter.setLabelRequired(false);
        }
      });
    }
  });
}
document.addEventListener("ajax-form-changed", function () {
  initMenuClickHandlers();
});

initMenuClickHandlers();